<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h3>{{ $t("SalonProvider.show_providers-update-request") }}</h3>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="getDataToShow">
        <div class="row">
          <h4>
            {{ $t("SalonProvider.salonData") }}
          </h4>

          <!-- Start:: Logo Image -->
          <div class="table_image_wrapper m-auto" v-if="data.logo.path">
            <base-image-upload-input
              col="12"
              identifier="image"
              :preSelectedImage="data.logo.path"
              :placeholder="$t('SalonProvider.salonLogo')"
              disabled
            />
          </div>
          <!-- End:: Item Image -->
          <!-- Start:: laundry Name Input -->
          <base-input
            col="6"
            type="text"
            v-if="data.salonNameAr"
            :placeholder="$t('SalonProvider.salonNameAr')"
            v-model.trim="data.salonNameAr"
            disabled
            :class="data.is_name_ar_changed ? 'highlight' : ''"
          />
          <base-input
            col="6"
            type="text"
            v-if="data.salonNameEn"
            :placeholder="$t('SalonProvider.salonNameEn')"
            v-model.trim="data.salonNameEn"
            disabled
            :class="data.is_name_en_changed ? 'highlight' : ''"
          />
          <base-input
            col="6"
            type="text"
            v-if="data.salonPhone"
            :placeholder="$t('SalonProvider.salonPhone')"
            v-model.trim="data.salonPhone"
            disabled
            :class="data.is_mobile_changed ? 'highlight' : ''"
          />
          <base-input
            col="6"
            type="text"
            v-if="data.salonEmail"
            :placeholder="$t('SalonProvider.salonEmail')"
            v-model.trim="data.salonEmail"
            disabled
            :class="data.is_email_changed ? 'highlight' : ''"
          />
          <!-- Start:: Item Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="image"
              v-if="data.commercialRegister"
              :preSelectedImage="data.commercialRegister"
              :placeholder="$t('SalonProvider.salonDocument')"
              disabled
            />
          </div>
          <!-- End:: Item Image -->
          <base-input
            col="6"
            type="text"
            v-if="data.salonDescAr"
            :placeholder="$t('SalonProvider.salonDescAr')"
            v-model.trim="data.salonDescAr"
            disabled
            :class="data.is_description_ar_changed ? 'highlight' : ''"
          />
          <base-input
            col="6"
            type="text"
            v-if="data.salonDescEn"
            :placeholder="$t('SalonProvider.salonDescEn')"
            v-model.trim="data.salonDescEn"
            disabled
            :class="data.is_description_en_changed ? 'highlight' : ''"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonType')"
            v-model.trim="whatType.name"
            disabled
            :class="data.is_type_changed ? 'highlight' : ''"
          />
          <base-select-input
            class="placeholder_input"
            col="6"
            v-if="data.type === 'salon' && data.subBranch.id"
            :optionsList="salons"
            :placeholder="$t('SalonProvider.mainSalonName')"
            v-model="data.subBranch"
            disabled
            :class="data.is_main_branch_changed ? 'highlight' : ''"
          />

          <div>
            <!-- Start:: Categories -->
            <h4
              class="w-25"
              :class="data.is_categories_changed ? 'highlight' : ''"
            >
              {{ $t("SalonProvider.salonCat") }}
            </h4>
            <div class="row my-4">
              <div
                class="category_wrapper col-2 mx-2 rounded"
                v-for="cat in data.categories"
              >
                <span v-if="cat" :alt="$t('TABLES.Providers.laundryImage')">{{
                  cat.name
                }}</span>
              </div>
            </div>
            <!-- End:: Categories -->
          </div>

          <hr />
          <h4>
            {{ $t("SalonProvider.salonAddress") }}
          </h4>
          <!-- Start:: Region Input -->
          <base-select-input
            class="placeholder_input"
            col="4"
            :optionsList="regions"
            :placeholder="$t('SalonProvider.salonRegion')"
            v-model="data.region"
            disabled
            :class="data.is_region_changed ? 'highlight' : ''"
          />

          <!-- Start:: Address Input -->
          <base-input
            col="8"
            type="text"
            :placeholder="$t('SalonProvider.address')"
            v-model.trim="data.address"
            disabled
            :class="data.is_address_changed ? 'highlight' : ''"
          />

          <!-- Start:: Map Address Input -->
          <div class="map_wrapper">
            <MapComponent
              v-if="data.lat && data.lng"
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              :class="
                data.is_lat_changed || data.is_long_changed
                  ? 'mapHighlight'
                  : ''
              "
            />
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- ======================== Start:: Dialogs ======================== -->
    <template>
      <!-- Start:: Image Modal -->
      <image-modal
        v-if="dialogImage"
        :modalIsOpen="dialogImage"
        :modalImage="modalImage"
        :type="selectedItemType"
        @toggleModal="dialogImage = !dialogImage"
      />
      <!-- End:: Image Modal -->
    </template>
    <!-- ======================== End:: Dialogs ======================== -->
  </div>
</template>

<script>
import MapComponent from "@/components/general/MapComponent.vue";
import ImageModal from "@/components/modals/ImageModal.vue";
export default {
  name: "ShowJoinProvider",
  components: {
    MapComponent,
    ImageModal,
  },
  computed: {
    types() {
      return [
        {
          id: 0,
          name: this.$t("SalonProvider.salon"),
          value: "salon",
        },
        {
          id: 1,
          name: this.$t("SalonProvider.freelance"),
          value: "freelancer",
        },
      ];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        logo: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        phone: null,
        salonNameAr: null,
        salonNameEn: null,
        salonPhone: null,
        salonEmail: null,
        salonDescAr: null,
        salonDescEn: null,
        commercialRegister: null,
        categories: [],
        type: null,
        subBranch: null,
        region: null,
        address: null,
        lat: null,
        lng: null,

        // Start:: Check Data
        is_name_changed: null,
        is_name_en_changed: null,
        is_name_ar_changed: null,
        is_description_changed: null,
        is_description_en_changed: null,
        is_description_ar_changed: null,
        is_mobile_changed: null,
        is_email_changed: null,
        is_type_changed: null,
        is_main_branch_changed: null,
        is_categories_changed: null,
        is_other_categories_changed: null,
        is_region_changed: null,
        is_address_changed: null,
        is_lat_changed: null,
        is_long_changed: null,
      },
      regions: [],
      salons: [],
      whatType: null,

      // End:: Data Collection To Send
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemType: null,
      modalImage: null,
    };
  },

  methods: {
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
        });
        console.log("regions", res);

        this.regions = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Salons To Show
    async getSalons() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `salons?ignorePermissionCheck=1`,
        });
        // Start:: Set Data
        const salonsData = res.data.data.data;
        this.salons = salonsData;
      } catch (error) {
        console.log(error);
      }
    },
    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemType = "image";
      this.modalImage = item;
    },

    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `update-salon-requests/${this.$route.params.id}`,
        });

        console.log("res", res);

        // Start:: Set Data
        const providerData = res.data.data.data;
        this.data.phone = providerData.mobile;
        this.data.name = providerData.name;
        this.data.logo.path = providerData.logo;
        this.data.salonNameAr = providerData.name_ar;
        this.data.salonNameEn = providerData.name_en;
        this.data.salonPhone = providerData.mobile;
        this.data.salonEmail = providerData.email;
        this.data.salonDescAr = providerData.description_ar;
        this.data.salonDescEn = providerData.description_en;
        this.data.type = providerData.type;
        this.data.subBranch = providerData.main_branch;
        this.data.commercialRegister = providerData.document;
        this.data.categories = providerData.categories;
        this.data.region = providerData.region;
        this.data.address = providerData.location.address;
        this.data.lat = providerData.location.lat;
        this.data.lng = providerData.location.long;
        // // End:: Set Data
        // Start:: Set Check Data
        this.data.is_name_changed = providerData.is_name_changed;
        this.data.is_name_en_changed = providerData.is_name_en_changed;
        this.data.is_name_ar_changed = providerData.is_name_ar_changed;
        this.data.is_description_changed = providerData.is_description_changed;
        this.data.is_description_en_changed =
          providerData.is_description_en_changed;
        this.data.is_description_ar_changed =
          providerData.is_description_ar_changed;
        this.data.is_mobile_changed = providerData.is_mobile_changed;
        this.data.is_email_changed = providerData.is_email_changed;
        this.data.is_type_changed = providerData.is_type_changed;
        this.data.is_main_branch_changed = providerData.is_main_branch_changed;
        this.data.is_categories_changed = providerData.is_categories_changed;
        this.data.is_other_categories_changed =
          providerData.is_other_categories_changed;
        this.data.is_region_changed = providerData.is_region_changed;
        this.data.is_address_changed = providerData.location.is_address_changed;
        this.data.is_lat_changed = providerData.location.is_lat_changed;
        this.data.is_long_changed = providerData.location.is_long_changed;

        if (this.data.type === "salon") {
          this.whatType = this.types[0];
        } else {
          this.whatType = this.types[1];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getSalons();
    this.getDataToShow();
    this.getRegions();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.table_image_wrapper {
  margin-bottom: 25px;
}

.category_wrapper {
  background: #b67071;
  text-align: center;
  font-size: medium;
  color: white;
}

.highlight {
  background: #f8d7da !important;
  border-color: #f5c6cb !important;
}

.mapHighlight {
  border: 5px solid #cf3444 !important;
}
</style>
